import { useCallback } from 'react';

import { Button } from '@/components/form/baseInputs/Button';
import { useNavigateToRoute } from '@/components/navigation/useNavigateToRoute';
import { ROUTE_KEYS } from '@/navigation/constants';

export interface UseImprovedAiSuggestionsAnnouncementProps {
  onClose: () => void;
  householdId: string;
}

export function useImprovedAiSuggestionsAnnouncement({
  onClose,
  householdId,
}: UseImprovedAiSuggestionsAnnouncementProps) {
  const { navigate } = useNavigateToRoute();

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  const handleTryItOut = useCallback(() => {
    navigate(ROUTE_KEYS.HOUSEHOLD_ESTATE_TRUSTS, {
      householdId,
    });
    handleClose();
  }, [handleClose, householdId, navigate]);

  return {
    heading: 'Improved AI Suggestions',
    imageUrl: 'improved-ai-suggestions.png',
    imageAlt: 'Improved AI Suggestions',
    bodyText:
      'We rebuilt how AI suggestions are generated, delivering significantly more accurate results \u2014 especially for dispositive provisions, complex beneficiaries, and sub-trusts.',
    actionButtons: (
      <Button variant="primary" size="sm" onClick={handleTryItOut}>
        Try it out
      </Button>
    ),
  };
}
